import React from 'react';
import { MarkupRender } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';

const ContentDescription = ({ className, description }) => {
    const classes = classnames("contentPageInfo", className);
    return <MarkupRender className={classes} tagName={'div'} content={description}/>;
};

export {
    ContentDescription
};
